import { rem } from 'polished';
import styled from 'styled-components';
import { mediaQueryWidth } from '../../common/breakpoints';
import { white } from '../../common/colors';
import { StyledPaddingContainer } from '../../common/padding.styles';

export const StyledBrandsCollectionsResults = styled(StyledPaddingContainer)`
  padding-top: 40px;
  background-color: ${white};

  & > button {
    display: block;
    margin: 10px auto;

    ${mediaQueryWidth({ min: 'mobile' })`
      margin: 40px auto 10px;
    `}
  }
`;

export const StyledBrandsCollectionsNoResults = styled(StyledPaddingContainer)`
  padding-top: ${rem(32)};
  padding-bottom: ${rem(32)};
`;
